<template>
  <div class="home">
    <div class="banner_box">
    <el-row :gutter="10">
      <el-col :span="18">
        <Banner></Banner>
      </el-col>
      <el-col :span="6"  style="margin-top:10px;padding:10px;">
        <el-row>
          <el-col :span="10">
            <img src="@/assets/image/customer_service.png" style="width:60px;height:60px;padding-left:20px;">
          </el-col>
          <el-col :span="14" style="color:white;">
            <p>热线电话：13485715181</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <img src="@/assets/image/portal.png" style="width:100px;height:100px;">
            </el-row>
            <el-row style="color:white;">
              <p>扫扫关注</p>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <img src="@/assets/image/cxtrace.png" style="width:100px;height:100px;">
            </el-row>
            <el-row  style="color:white;">
              <p>点点溯源</p>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    </div>
    <el-row>
      <div class="module_box">
        <el-row :gutter="10">
          <el-col :span="6">
            <div>
              <el-row>
                <img width="160px" height="160px" src="@/assets/image/iot.png">
              </el-row>
              <el-row >
                <el-link :underline="false" type="info"  style="font-size:20px;" target="_blank">生态环境监测</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;" target="_blank">河湖水质监测</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">生态农业监测</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">生产物联监测</el-link>
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-row>
                <img width="160px" height="160px" src="@/assets/image/trace.png">
              </el-row>
              <el-row >
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">农资防伪溯源</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">食品防伪溯源</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">饮品防伪溯源</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">原料防伪溯源</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">其他防伪溯源</el-link>
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-row>
                <img width="160px" height="160px" src="@/assets/image/service.png">
              </el-row>
              <el-row >
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">闲置资源服务</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">家政家教服务</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">社区配送服务</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">社区互助服务</el-link>
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-row>
                <img width="160px" height="160px" src="@/assets/image/advice.png">
              </el-row>
              <el-row >
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">防伪溯源咨询</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">环保监测咨询</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">生态农业咨询</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">数据采集咨询</el-link>
              </el-row>
              <el-row>
                <el-link :underline="false" type="info"  style="font-size:20px;"  target="_blank">信息化建设咨询</el-link>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'

export default {
  name: 'home',
  components: {
    Banner
  }
}
</script>

<style lang="less" scoped>
.banner_box {
  width: 100%;
  z-index: 999;
  height: 300px;
  padding: 10px;
  background: url('../assets/image/banner_bg.png') no-repeat;
  background-size: 100%;
  border: 00ff00;
  overflow: hidden;
}
.module_box {
  width: 100%;
  z-index: 999;
  height: 400px;
  padding: 10px;
  background: #ffffff;
  overflow: hidden;
}
.el-row {
  margin-top: 10px;
}
a:link {
  text-decoration:none;
  cursor:pointer;
  font-size: 19px;
  }
</style>
